import { createSlice } from '@metorial/microfrontend';
import { AccountPage } from './pages';
import { AccountPageLayout } from './pages/_layout';
import { AccountPortalsPage } from './pages/portals';

// Account area (cloud-spec §8): Profile and Portals. Google Workspace is the
// only identity, so there are no emails/password/SSO pages.
export let accountSlice = createSlice([
  {
    path: '',
    element: <AccountPageLayout />,
    children: [
      { path: '', element: <AccountPage /> },
      { path: 'profile', element: <AccountPage /> },
      { path: 'portals', element: <AccountPortalsPage /> }
    ]
  }
]);
